module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.hasSelect(),
      "title": "Importálás Excel fájlból"
    },
    on: {
      "click": function($event) {
        _vm.popup.import = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.hasSelect(),
      "title": "Mentés"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), (_vm.hasSelect()) ? _c('button', {
    staticClass: "fl-button",
    attrs: {
      "title": "Email küldés"
    },
    on: {
      "click": _vm.mail
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]) : _vm._e()]), _vm._v(" "), _c('h1', [_vm._v("Vonalkód beállítás")]), _vm._v(" "), (_vm.barcodes.length > 0) ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('table', {
    staticClass: "list"
  }, [_c('tr', [_c('th', [_c('checkbox', {
    key: "all_select",
    attrs: {
      "disabled": !_vm.visibleAllSelect(),
      "id": "all_select"
    },
    model: {
      value: (_vm.all_select),
      callback: function($$v) {
        _vm.all_select = $$v
      },
      expression: "all_select"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("Rf ID / Szám")]), _vm._v(" "), _c('th', [_vm._v("Név / Email")]), _vm._v(" "), _c('th', [_vm._v("Rendszám")]), _vm._v(" "), _c('th', [_vm._v("Jog")]), _vm._v(" "), _c('th', [_vm._v("Kezdő dátum")]), _vm._v(" "), _c('th', [_vm._v("Időtartam (óra)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, _vm._l((_vm.access_levels), function(al) {
    return _c('checkbox', {
      staticStyle: {
        "padding-bottom": "5px"
      },
      attrs: {
        "label": al.name,
        "name": "all_access_level_id[]",
        "id": 'all_access_level_id_' + al.id,
        "val": al.id
      },
      on: {
        "input": _vm.allAccessLevelChange
      },
      model: {
        value: (_vm.all_access_level_id),
        callback: function($$v) {
          _vm.all_access_level_id = $$v
        },
        expression: "all_access_level_id"
      }
    })
  }), 1), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('inputbox', {
    key: "all_start_date_time",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "datepicker": {
        enableTime: true
      },
      "label": "",
      "id": "all_start_date_time"
    },
    on: {
      "input": _vm.allStartDateTimeChange
    },
    model: {
      value: (_vm.all_start_date_time),
      callback: function($$v) {
        _vm.all_start_date_time = $$v
      },
      expression: "all_start_date_time"
    }
  })], 1), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [(_vm.$root.user.barcode_period_fix == 0) ? _c('inputbox', {
    key: "all_period",
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "regexp_filter": "[0-9]+",
      "label": "",
      "id": "all_period"
    },
    on: {
      "input": _vm.allPeriodChange
    },
    model: {
      value: (_vm.all_period),
      callback: function($$v) {
        _vm.all_period = $$v
      },
      expression: "all_period"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm._l((_vm.barcodes), function(barcode) {
    return _c('tr', [_c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('checkbox', {
      key: 'barcode_selected_' + barcode.id,
      attrs: {
        "disabled": !barcode.email_can_be_sent,
        "id": 'barcode_selected_' + barcode.id,
        "val": "1"
      },
      model: {
        value: (barcode.selected),
        callback: function($$v) {
          _vm.$set(barcode, "selected", $$v)
        },
        expression: "barcode.selected"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(barcode.rf_id))]), _c('br'), _vm._v(_vm._s(barcode.barcode_number)), (barcode.email_sent == 1) ? _c('div', [_c('i', {
      staticClass: "fa fa-envelope"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(barcode.email_sent_user_name) + " (" + _vm._s(barcode.email_sent_user_email) + ")")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('inputbox', {
      key: 'barcode_name_' + barcode.id,
      staticStyle: {
        "width": "200px",
        "padding-bottom": "0px"
      },
      attrs: {
        "disabled": !barcode.editable,
        "placeholder": "Kedvezményezett neve",
        "errors": _vm.errors,
        "label": "",
        "id": 'barcode_name_' + barcode.id
      },
      on: {
        "input": function($event) {
          barcode.email_can_be_sent = false;
          barcode.selected = false;
          _vm.all_select = false;
        }
      },
      model: {
        value: (barcode.name),
        callback: function($$v) {
          _vm.$set(barcode, "name", $$v)
        },
        expression: "barcode.name"
      }
    }), _vm._v(" "), _c('inputbox', {
      key: 'barcode_email_' + barcode.id,
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "disabled": !barcode.editable,
        "placeholder": "Kedvezményezett email címe",
        "errors": _vm.errors,
        "label": "",
        "id": 'barcode_email_' + barcode.id
      },
      on: {
        "input": function($event) {
          barcode.email_can_be_sent = false;
          barcode.selected = false;
          _vm.all_select = false;
        }
      },
      model: {
        value: (barcode.email),
        callback: function($$v) {
          _vm.$set(barcode, "email", $$v)
        },
        expression: "barcode.email"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('inputbox', {
      key: 'barcode_license_plate_' + barcode.id,
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "disabled": !barcode.editable,
        "regexp_filter": "[0-9a-zA-Z]+",
        "errors": _vm.errors,
        "label": "",
        "id": 'barcode_license_plate_' + barcode.id
      },
      on: {
        "input": function($event) {
          barcode.email_can_be_sent = false;
          barcode.selected = false;
          _vm.all_select = false;
        }
      },
      model: {
        value: (barcode.license_plate),
        callback: function($$v) {
          _vm.$set(barcode, "license_plate", $$v)
        },
        expression: "barcode.license_plate"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_vm._l((_vm.access_levels), function(al) {
      return _c('checkbox', {
        staticStyle: {
          "padding-bottom": "5px"
        },
        attrs: {
          "disabled": !barcode.editable,
          "label": al.name,
          "name": 'barcode_access_levels_' + barcode.id + '[]',
          "id": 'barcode_access_levels_' + barcode.id + '_' + al.id,
          "val": al.id
        },
        on: {
          "input": function($event) {
            barcode.email_can_be_sent = false;
            barcode.selected = false;
            _vm.all_select = false;
          }
        },
        model: {
          value: (barcode.access_levels),
          callback: function($$v) {
            _vm.$set(barcode, "access_levels", $$v)
          },
          expression: "barcode.access_levels"
        }
      })
    }), _vm._v(" "), _vm._l((_vm.errors), function(error) {
      return (error.id == 'barcode_access_levels_' + barcode.id) ? _c('div', {
        staticClass: "form-error"
      }, [_vm._v("\n              Kötelező\n            ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('inputbox', {
      key: 'barcode_start_date_time_' + barcode.id,
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "disabled": !barcode.editable,
        "datepicker": {
          enableTime: true
        },
        "errors": _vm.errors,
        "label": "",
        "id": 'barcode_start_date_time_' + barcode.id
      },
      on: {
        "input": function($event) {
          barcode.email_can_be_sent = false;
          barcode.selected = false;
        }
      },
      model: {
        value: (barcode.start_date_time),
        callback: function($$v) {
          _vm.$set(barcode, "start_date_time", $$v)
        },
        expression: "barcode.start_date_time"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('inputbox', {
      key: 'barcode_period_' + barcode.id,
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "disabled": !barcode.editable,
        "regexp_filter": "[0-9]+",
        "errors": _vm.errors,
        "label": "",
        "id": 'barcode_period_' + barcode.id
      },
      on: {
        "keyup": function($event) {
          return _vm.periodKeyup(barcode)
        },
        "input": function($event) {
          barcode.email_can_be_sent = false;
          barcode.selected = false;
        }
      },
      model: {
        value: (barcode.period),
        callback: function($$v) {
          _vm.$set(barcode, "period", $$v)
        },
        expression: "barcode.period"
      }
    })], 1)])
  })], 2)]) : _c('div', [_vm._v("\n      Nem található vonalkód.\n    ")])]), _vm._v(" "), (_vm.popup.import) ? _c('import-popup', {
    attrs: {
      "request_id": _vm.$route.query.id
    },
    on: {
      "close": function($event) {
        _vm.popup.import = false
      },
      "success": _vm.getBarcodes
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f55b2dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/barcode/setup.vue
// module id = 319
// module chunks = 0